import Vue from "vue";
import store from "../../store/index";
const AuthStore = store.state.auth; // !!! AuthStore.user IS NOT AVAILABLE HERE, THAT IS WHY WE GET AUTHSTORE ONLY
import SubspaceAPI from "./SubspaceAPI";
import { ELYXCentralStore, SidebarElementStore, SpaceStore, SubspaceStore } from "../ELYXStore";
import ItemMethods from "../Items/ItemMethods";
import ELYXUpdater, { checkFieldsHaveChanged, ensureUpdateTrackerIsInitialized, syncRecentlyChangedField } from "../ELYXUpdater";
import ELYXUtils from "../ELYXUtils";
import ELYXConstants from "../ELYXConstants";

const SubspaceMethods = {
  setCreatingSubspace(input) {
    SubspaceStore.methods.setCreatingSubspace(true);
    Vue.nextTick(() => input.focus());
  },

  setSubspaceNameInput(newValue) {
    SubspaceStore.methods.setSubspaceNameInput(newValue);
  },

  resetCreatingSubspace() {
    SubspaceStore.methods.setCreatingSubspace(false);
    SubspaceStore.methods.setSubspaceNameInput("");
  },

  async getSubspaceContents(subspaceID, skip = 0) {
    const spaceID = SpaceStore.state.space._id;
    const response = await SubspaceAPI.getSubspaceContents(AuthStore.user._id, spaceID, subspaceID, skip);
    if (!response || !response.success || !response.data) {
      throw new Error("Request failed.");
    }

    /** Initialize context, whether items is empty array or has contents. */
    ItemMethods.initItemsContext(response.data.items);
  },

  async updateSubspaceName(delayed = false) {
    const subspace = SubspaceStore.state.subspace;
    const subspaceID = subspace._id;

    /** Prepare request data */
    const updateData = { UID: AuthStore.user._id, subspaceID, name: subspace.name ?? "" };

    const field = "name";

    /** Cancel update early if no fields have changed */
    if (!checkFieldsHaveChanged(subspaceID, field)) {
      return;
    }

    /** Wait to update to ensure previous debounce timeout has finished for
     * delayed requests; non-delayed requests don't have this issue and are
     * executed immediately. */
    if (delayed) {
      await ELYXUtils.delay(1000);
    }

    await ELYXUpdater({
      ID: subspaceID,
      update: SubspaceAPI.updateSubspaceName,
      updateData,
      delayed,
      field,
      updateTimeMS: Date.now(),
    });
  },

  async syncSubspaceName(newValue) {
    const subspace = SubspaceStore.state.subspace;
    const subspaceID = subspace._id;
    const oldValue = subspace.name ?? "";

    /** Abort update as values have not changed */
    if (oldValue === newValue) return;

    /** Ensure tracking is initialized for subspace */
    ensureUpdateTrackerIsInitialized(subspaceID);

    /** Sync recently changed fields */
    syncRecentlyChangedField(subspaceID, "name");

    /** If subspace is currently selected, sync its name value */
    if (subspace._id && subspace._id === subspaceID) {
      SubspaceStore.methods.syncSubspaceName(newValue);
    }

    /** Update subspace name in sidebar */
    SidebarElementStore.methods.updateSidebarElementNameByRefID(subspaceID, newValue);

    /** Initialize a delayed subspace name update */
    const delayed = true;
    await SubspaceMethods.updateSubspaceName(delayed);
  },

  handleSuccessfulSubspaceUpdate() {},

  handleFailedSubspaceUpdate() {},

  async deleteSubspace() {
    /** Close delete modal */
    SubspaceMethods.closeDeleteModal();

    /** Store subspace and sidebar element backups */
    const subspaceBackup = SubspaceStore.state.subspace;
    const sidebarElementBackup = SidebarElementStore.methods.findSidebarElementByRefID(subspaceBackup._id);

    /** Clear subspace for fast UX of deleting subspace */
    SubspaceStore.methods.clearSubspace();

    /** Remove sidebar element from sidebar for fast UX */
    SidebarElementStore.methods.removeSidebarElementByRefID(subspaceBackup._id);

    /** Attempt delete subspace from database */
    const response = await SubspaceAPI.deleteSubspace(AuthStore.user._id, subspaceBackup._id);
    if (!response || !response.success) {
      /** If delete fails, restore subspace items and sidebar element */
      SubspaceStore.methods.setSubspace(subspaceBackup);
      SidebarElementStore.methods.addElementBackToSidebar(sidebarElementBackup);
    }
  },

  openDeleteModal() {
    SubspaceStore.methods.closeAllSubspaceDropdowns();
    ELYXCentralStore.methods.setModal(ELYXConstants.modals.SubspaceModalDeletion);
  },
  closeDeleteModal() {
    ELYXCentralStore.methods.closeModal();
  },
};

export default SubspaceMethods;
